var map = {
	"./bn/messages.po": [
		3776,
		776
	],
	"./en/messages.po": [
		1015,
		15
	],
	"./fake/messages.po": [
		9598,
		598
	],
	"./gu/messages.po": [
		5566,
		566
	],
	"./hi/messages.po": [
		5002,
		2
	],
	"./kn/messages.po": [
		6450,
		450
	],
	"./ml/messages.po": [
		3215,
		215
	],
	"./mr/messages.po": [
		7985,
		985
	],
	"./ta/messages.po": [
		8873,
		873
	],
	"./te/messages.po": [
		8667,
		667
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6470;
module.exports = webpackAsyncContext;